import { useCallback } from "react";

/**
 * Hook para manejar la acción de agregar una fila en la grilla editable.
 * @param {object} dataGridRef - Referencia al componente DataGrid
 * @returns {function} addRow - Función para agregar una fila
 */
export function useAddRow(dataGridRef) {
    return useCallback(() => {
        if (dataGridRef?.current) {
            dataGridRef.current.addRow();
        }
    }, [dataGridRef]);
}
